// extracted by mini-css-extract-plugin
export default {"MainDiv":"HowWorks_MainDiv__233TR","MapDiv":"HowWorks_MapDiv__DdCzn","titledDiv":"HowWorks_titledDiv__f5w2B","footer":"HowWorks_footer__M++pv"};